import ThreadTranslationEditorVM from './threadTranslation';

export default class ThreadTranslationEditorVMValidator {
    constructor(private editor: ThreadTranslationEditorVM) { }

    validate() {
        return [
            this.validateContent()
        ].find(err => err != undefined);
    }

    validateContent() {
        if (this.editor.content().trim().length === 0)
            return messages.MessageCantBeEmpty;
    }
}